import React from 'react';
import aboutUs from '../assets/human-ai-harmony.png';

export default function AboutUs() {
  return (
      <section className="py-16 bg-white" id="about">
        <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center gap-12">
          
          {/* Image Box - Larger and Centered */}
          <div className="w-full md:w-1/2 flex justify-center">
            <img src={aboutUs} alt="About Us" className="w-full h-auto max-w-md md:max-w-xl rounded-lg shadow-lg" />
          </div>

          {/* Text Content - Better Width & Padding */}
          <div className="w-full lg:w-1/2 p-8">
            <h2 className="text-4xl font-bold mb-6 text-center md:text-left">About Us</h2>

            <p className="text-gray-700 mb-4 text-justify leading-relaxed">
              At AquaMind AI, we harness the power of artificial intelligence to elevate businesses, optimize operations, and drive growth.
            </p>

            <p className="text-gray-700 mb-4 text-justify leading-relaxed">
              Our mission is to empower organizations of all sizes with <b>tailored AI solutions </b> 
              that enhance productivity and innovation. Whether you're a solopreneur streamlining tasks 
              or an enterprise optimizing workflows, our AI agents <b>seamlessly integrate</b> with your needs to boost efficiency.
            </p>

            <p className="text-gray-700 mb-4 text-justify leading-relaxed">
              With a strong focus on <b>security, privacy, and seamless integration</b>, we ensure your data stays protected 
              while aligning AI with your business. At AquaMind AI, we make AI <b>accessible, actionable, 
              and transformative</b>, helping you turn challenges into opportunities.
            </p>
          </div>

        </div>
      </section>

  );
}
